(ns kyber.components.base.link
  (:require [kyber.components.base.text :refer [body-20]]
            [kyber.styles.core :refer [styles->classes gs]]
            [kyber.utils :as ku]))

;; ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;; Link
;; ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;

(def link-styles
  {:cursor :pointer
   :margin (gs [:spacing :p0])
   :font-size (gs [:font-size :body-20])
   :font-weight (gs [:font-weight :body-20])
   :font-family (gs [:font-family :open-sans])
   :line-height (gs [:font-height :body-20])
   :text-decoration :none
   :color (gs [:colors :primary-lite-700])
   "&:active" {:color (gs [:colors :primary-lite-500])}

   (gs [:queries :hover])
   {"&:hover" {:color (gs [:colors :primary-lite-800])}}

   (gs [:queries :tablet])
   {:font-size (gs [:font-size :body-20/tablet])}

   (gs [:queries :mobile-landscape])
   {:font-size (gs [:font-size :body-20/mobile])}})

(def link-classes
  (styles->classes {:link link-styles}))

(defn link
  {:doc "Link"}
  ([copy] [link {} copy])
  ([{:keys [class] :as options} copy]
   [:a (assoc options :class
              (cond-> [(:link link-classes)]
                (string? class) (conj class)
                (coll? class) (concat class)))
    copy]))

;; ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;; Anchor Button
;; ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;

(def base-anchor-button-styles
  {:width :max-content
   :display :flex
   :justify-content :center
   :appearance :none
   :align-items :center
   :text-transform :capitalize
   :text-decoration :none
   :white-space :nowrap
   :padding [[(gs [:spacing :p8])
              (gs [:spacing :p20])]]
   :cursor :pointer
   :user-select :none
   :transition "all 100ms linear"

   "&.disabled"
   {:cursor :default
    :background-color (gs [:colors :gray-scale-200])

    "&:active"
    {:background-color (gs [:colors :gray-scale-200])}}})

(def primary-anchor-button-styles
  (merge base-anchor-button-styles
         {:background-color (gs [:colors :primary-lite-600])
          "& span" {:color (gs [:colors :true-white])
                    :font-size "12px"
                    :font-weight (gs [:font-weight :title-10])}
          "&:focus" {:outline (gs [:spacing :p0])
                     :border-image :none}
          "&:active" {:background-color (gs [:colors :primary-lite-400])}

          (gs [:queries :hover])
          {"&:hover" {:background-color (gs [:colors :primary-lite-700])}}}))

(def secondary-anchor-button-styles
  (merge base-anchor-button-styles
         {:box-shadow (str "inset 0 0 0 1px " (gs [:colors :gray-scale-300]))
          :background (gs [:colors :true-white])
          "& span" {:color (gs [:colors :primary-lite-600])}
          "&:focus" {:outline (gs [:spacing :p0])
                     :border-image :none}
          "&:active" {:background-color (gs [:colors :primary-lite-400])
                      :border-color (gs [:colors :primary-lite-400])}
          "&:active span" {:color (gs [:colors :true-white])}

          (gs [:queries :hover])
          {"&:hover" {:background-color (gs [:colors :primary-lite-700])
                      :box-shadow (str "inset 0 0 0 1px " (gs [:colors :primary-lite-700]))}
           "&:hover span" {:color (gs [:colors :true-white])}}}))

(def transparent-anchor-button-styles
  (merge base-anchor-button-styles
         {:border (str (gs [:spacing :p1])
                       " solid "
                       (ku/hex->rgba (gs [:colors :true-white]) 0.5))
          :background :none

          "& span"
          {:color (gs [:colors :true-white])}

          "&:active" {:background-color (gs [:colors :true-white])
                      "& span" {:color (gs [:colors :primary-lite-600])}}
          "&:hover" {:background-color (gs [:colors :primary-lite-600])}}))

(def ^{:private true} anchor-button-classes
  (styles->classes
   {:primary-anchor-button primary-anchor-button-styles
    :secondary-anchor-button secondary-anchor-button-styles
    :transparent-anchor-button transparent-anchor-button-styles}))

(defn- render-anchor-button
  [{:keys [class] :as options} copy anchor-button-class]
  [:a (cond-> (assoc options :class anchor-button-class)
        class (update :class #(str % " " class)))
   [body-20 :span copy]])

(defn primary-anchor-button
  {:doc "Primary anchor button"}
  ([copy] [primary-anchor-button {} copy])
  ([options copy]
   [render-anchor-button
    options copy (:primary-anchor-button anchor-button-classes)]))

(defn secondary-anchor-button
  {:doc "Secondary anchor button"}
  ([copy] [secondary-anchor-button {} copy])
  ([options copy]
   [render-anchor-button
    options copy (:secondary-anchor-button anchor-button-classes)]))

(defn transparent-anchor-button
  {:doc "Transparent anchor button"}
  ([copy] [transparent-anchor-button {} copy])
  ([options copy]
   [render-anchor-button
    options copy (:transparent-anchor-button anchor-button-classes)]))
